import { FormControl, FormGroup, InputGroup, FormLabel } from "react-bootstrap";
import { useState, useEffect, useRef } from "react";
import { getRandomId } from "../util/utils.js";
import { BarcodeScanner } from "./BarcodeScanner.js";

export function SimpleFormField(props) {
	let {
		// Display / HTML
		id,             // HTML ID
		label,          // Text Label
		name,           // HTML name
		placeholder,    // In-Text Placeholder
		scannable,      // Show scan button?
		type,           // Type of input (text/textarea) [default text]
		color,
		disabled,

		// Data & I/O
		inputRef,       // Allows you to ref the input field
		defaultValue,   // Specify default value (only if bind is empty)
		value,          // Value in the form field
		bindObject,     // Auto-updatable object
		bindAttribute,  // Auto-updatable attribute

		// Actions
		onScan,         // If this is set, and triggers, it should return true to halt the processing chain, and false otherwise
		afterScan,      // This happens after a scan if onScan doesn't halt the chain
		onChange,       // This happens on any change, unless onScan stops the chain
		onBlur,         // This happens when focus is about to be lost

		...passableProps
	} = props;

	// State
	let [scanning, setScanning] = useState(false);
	let [myId] = useState(getRandomId(id)); // Using useState gets a stable ID even though it is randomly generated
	let scannerId = `${myId}_scannner`;
    let inputId = `${myId}_input`;

	// Refs
	let tmpRef = useRef();
	let myInputRef = inputRef || tmpRef;

	// Further Setup
    let dValue = defaultValue || "";

	let myOnChange = onChange; // trigger any changes
	if(bindObject != null && bindAttribute != null) {
		dValue = bindObject[bindAttribute];
		myOnChange = (evt) => {
			bindObject[bindAttribute] = evt.target.value;
			onChange?.(evt);
		}
	}

	// Controller Actions
    let toggleScanning = async () => {
        setScanning(!scanning);
    }

	// BarcodeScanner wants a non-async function that returns true (so it can stop scanning)
	let onScanOccurrence = (decodedText) => {
		onScanOccurrenceAsync(decodedText);
		return true;
	}
	
	let onScanOccurrenceAsync = async (decodedText) => {
		setScanning(false);

		// If there is an onScan handler, that takes precedence
		if(onScan != null) {
			if(onScan(decodedText)) {
				// "true" means that the onScan was able to handle the request
				setScanning(false);
				return;
			}
		}

		// Update widget
		setScanning(false);
		myInputRef.current.value = decodedText;

		// Be sure any triggers are properly called
		if(myOnChange) {
			let evt = new Event("change", {bubbles: false});
			// The following is required for setting the target property properly
			Object.defineProperty(evt, "target", {writable: false, value: myInputRef.current});
			myOnChange(evt);    
		}
		if(afterScan) {
			let evt = new Event("scanned", {bubbles: false});
			Object.defineProperty(evt, "target", {writable: false, value: myInputRef.current});
			afterScan(evt);
		}
	};

    return (
        <div id={myId} {...passableProps}>
            <FormGroup>
                {label && <FormLabel style={{color:color}}>{label}</FormLabel>}
                <InputGroup>
                    <FormControl ref={myInputRef} id={inputId} type={type || "text"} className={"input " + (type || "text")} name={name} defaultValue={ dValue } value={value} disabled={disabled} onChange={myOnChange} placeholder={placeholder} onBlur={onBlur} />
                    {scannable && <div className="input-group-append" onClick={toggleScanning}><span className="input-group-text">{scanning ? "Cancel" : "Scan"}</span></div>}
                </InputGroup>
            </FormGroup>
            {scanning && <BarcodeScanner onScan={onScanOccurrence} id={scannerId} style={{minHeight: "250px", "backgroundColor": "white"}} />}
        </div>
    );
}